<template>
  <div class="main-wrapper">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="btn-wrapper">
          <el-button icon="el-icon-plus" type="primary" @click="addModal('新增角色')">新增角色</el-button>
        </div>
        <ex-table showPagination :data="tableData" :height="tableHeight" ref="table"
                  :search-method="handleChange" border @row-click="loadUserData">
          <ex-table-col prop="roleName" label="角色名称"></ex-table-col>
          <ex-table-col prop="roleDesc" label="描述"></ex-table-col>
          <ex-table-col :width="140" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button title="编辑" class="circle-btn" type="primary" @click="edit(scope.row)" icon="el-icon-edit" circle></el-button>
              <el-button title="授权" class="circle-btn" type="primary" @click="setAuth(scope.row)" icon="el-icon-key" circle></el-button>
              <el-button title="删除" class="circle-btn" type="primary" @click="remove(scope.row.id)" icon="el-icon-delete" circle></el-button>
            </template>
          </ex-table-col>
        </ex-table>
      </el-col>
      <el-col :span="12">
        <div class="btn-wrapper" style="margin-bottom: 10px;">
        <h2>角色对应用户列表</h2>
        </div>
        <ex-table showPagination :data="userTableData" :height="tableHeight" ref="userTable"
                  :search-method="handleChange1" border>
          <ex-table-col prop="userName" label="用户名"></ex-table-col>
          <ex-table-col prop="name" label="姓名"></ex-table-col>
          <ex-table-col prop="phoneNumber" label="电话号码"></ex-table-col>
          <ex-table-col prop="birthday" label="生日"></ex-table-col>
          <ex-table-col prop="sexName" label="性别"></ex-table-col>
          <ex-table-col prop="createDate" label="注册时间"></ex-table-col>
        </ex-table>
      </el-col>
    </el-row>
    <edit-modal  :title="currentTitle" :rowId="currentId" v-if="isShowEdit" @ok="onModalOk" :mode="editMode" @close="isShowEdit=false"></edit-modal>
    <auth v-if="isShowAuth" :roleId="currentId" :title="authTitle" @ok="isShowAuth=false" @close="isShowAuth=false"></auth>
  </div>
</template>
<script>
  import pageMixin from "@/mixin/tablePage"
  import editModal from "./edit"
  import {getAction} from "@/service/http/api";
  import auth from './auth'

  export default {
    name:'RoleManagement',
    mixins:[pageMixin],
    components:{
      'edit-modal':editModal,
      auth
    },
    data(){
      return{
        tableHeight: window.innerHeight - 290,
        page: 1,
        pageSize: 10,
        userPage:1,
        userPageSize:10,
        tableData:[],
        userTableData:[],
        currentId:null,
        isShowEdit:false,
        currentTitle:null,
        editMode:'new',
        isShowAuth:false,
        authTitle:null,
        url:{
          list:'/role/list',
          userList:'/role/queryUsersByRoleId',
          remove:'/role/deleteById',
          removeMore:'/role/batchDelete'
        }
      }
    },
    methods:{
      handleChange1(pagination, {currentPage, pageSize}) {
        this.userPage = pageSize;
        this.userPageSize = currentPage;
        this.loadUserData();
      },
      loadUserData(row){
        let para = {
          pageIndex:this.page,
          pageSize:this.pageSize,
          id:row.id
        };
        getAction(this.url.userList,para).then(res => {
          if (res.code === 200) {
            this.userTableData = res.data.records;
            const pagination = this.$refs.userTable.pagination;
            pagination.total = res.data.total;
          }
        })
      },
      edit(row){
        this.currentTitle = '编辑' + row.roleName;
        this.editModal(row);
      },
      setAuth(row){
        this.currentId=row.id;
        this.authTitle =row.roleName +  '权限配置';
        this.isShowAuth = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/role_management/role_management.vue